
import { http, HttpResponse } from "msw";
import { ipAddressChangesData } from "./data/ipmanage";
import { IpChangesType } from "../model";
  
export default [
  /**
   * 내 G코인 사용 상세 조회
   * [GET] /gcoin/me/usages/detail?startDate={startDate}&endDate={endDate}&index={index}&size={size}
   */
  http.get("/api-proxy/ipmanage/me/ipchanges", async ({ request, params, cookies }) => {
    const url = new URL(request.url);
    const startDate = url.searchParams.get("startDate");
    const endDate = url.searchParams.get("endDate");
    const page = url.searchParams.get("pageIndex");
    const size = url.searchParams.get("pageSize");

    const startIndex = (Number(page) - 1) * Number(size);
    const endIndex = startIndex + Number(size);

    const ipAddressChangesSlice = ipAddressChangesData.slice(startIndex, endIndex);
    const resultData = {
      ipAddressChanges: ipAddressChangesSlice,
      totalCount: ipAddressChangesData.length,
    }

    let result;

    if (resultMap.has(JSON.stringify({ startDate, endDate, page, size }))) {
      result = resultMap.get(JSON.stringify({ startDate, endDate, page, size }));
    } else {
      result = resultData;
      resultMap.set(JSON.stringify({ startDate, endDate, page, size }), result);
    }

    // console.log(resultMap);
    if(page !== '1') {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(
            HttpResponse.json(
              {
                errorCode: "TEST",
                message: "Missing session",
              },
              { status: 404 },
            ),
          );
        }, 1000);
      });
    }
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(HttpResponse.json(result));
      }, 1000);
    });
  }),
];

const resultMap = new Map<any, IpChangesType>();
